import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { GenericDecimalInput } from '../../components';


const PremiumPaymentWarrantyInput: InputWithoutSource = ({ input }) => (
    <GenericDecimalInput label={input.name} input={input} precision={0} />
);

PremiumPaymentWarrantyInput.meta = {
    inputType: InputModel.name
};

export default observer(PremiumPaymentWarrantyInput);
